import { Spin } from 'antd';
import styled from 'styled-components';

const StyledDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

const Loader = () => {
	return (
		<StyledDiv>
			<Spin size="large" />
		</StyledDiv>
	);
};

export default Loader;
